module.exports = __webpack_public_path__ + "static/nath-60c303511c6b6ddb4785130718889059.png";